import { GameDetails } from '../Metadata.types'

import Schema from './Schema'
import { organizationSchema } from './Schema.util'

interface Props {
  gameDetails: GameDetails
}

function createSchemaObject(gameDetails: GameDetails): any {
  return {
    '@context': 'https://schema.org',
    '@type': 'VideoGame',
    name: gameDetails.name,
    image: gameDetails.image,
    description: gameDetails.description,
    genre: gameDetails.genre,
    playMode: gameDetails.playMode,
    typicalAgeRange: gameDetails.typicalAgeRange,
    url: `https://www.houseofmath.com${gameDetails.url}`,
    gamePlatform: ['Mobile game', 'PC game', 'Android', 'iOS'],
    author: organizationSchema,
  }
}

const GamesSchema = ({ gameDetails }: Props): React.ReactElement => {
  const schemaObject = createSchemaObject(gameDetails)

  return <Schema schemaObject={schemaObject} />
}

export default GamesSchema
